module.exports = "pegasus_template/assets/background-patterns/theme6_theme.gif";